import { Panel } from 'models/Panel/Panel';
import { WidgetSmartTrends } from 'src/stores/PanelTemplatesStore/WidgetSmartTrends';
import merge from 'deepmerge';
import _cloneDeep from 'lodash/cloneDeep';
import { DefaultPosition } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/constants';
const getMergedWidget = () => {
    const widget = _cloneDeep(WidgetSmartTrends);
    widget.options = merge(widget.options, {
        smartTrends: { fontScale: 30 },
    });
    widget.position = DefaultPosition;

    return widget;
};

export const TemplateSmartTrends: Panel = {
    id: 'smart-trends',
    name: 'Trend Cards',
    description: '',
    tags: ['Content', 'Posts', 'Smart Trends', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_smart_trends',
        children: [getMergedWidget()],
        theme: {
            ext: {
                padding: 20,
            },
        },
    },
};
